
export default
  name: 'stylesheet-restaurant'
  props:
    stylesheet:
        required: true
        type: String
  render: (h) ->    
    h('style', { attrs: { id: 'stylesheet-restaurant' } }, @stylesheet)    
